/* eslint-disable */
export const quizData = {
  "questions": [
    {
      "id": "start",
      "type": "start",
      "step": "1",
      "title": "start",
      "text": "Hi there! I’m Farmer Jen.",
      "description": "During the next few minutes, I’ll ask you a few questions and make product recommendations based on your answers.",
      "buttonText": "Get Started",
      "nextQuestion": "intro"
    },
    {
      "id": "intro",
      "type": "input",
      "step": "2",
      "title": "intro",
      "text": "Tell us a little about yourself",
      "blocks": [
        {
          "id": "firstName",
          "type": "text",
          "inputTag": "input",
          "placeholder": "First Name",
          "inputLabel": "My name is"
        },
        {
          "id": "role",
          "type": "select",
          "inputTag": "select",
          "placeholder": "Select One",
          "inputLabel": "I am a",
          "options": [
            {
              "label": "Parent",
              "value": "parent"
            },
            {
              "label": "Caregiver",
              "value": "caregiver"
            },
            {
              "label": "Grandparent",
              "value": "grandparent"
            },
            {
              "label": "Relative",
              "value": "relative"
            }
          ]
        }
      ],
      "buttonText": "Next",
      "nextQuestion": "children",
      "tip": "Tell us your name and your relation to your little one!",
      "useInResultsQuery": false
    },
    {
      "id": "children",
      "type": "input",
      "step": "3",
      "title": "children",
      "text": "I'm shopping for:",
      "blocks": [
        {
          "id": "childName0",
          "type": "text",
          "inputLabel": "Name",
          "inputTag": "input",
          "placeholder": ""
        }
      ],
      "buttonText": "Next",
      "nextQuestion": "birthday",
      "tip": "This helps us recommend the right plan and recipes!",
      "useInResultsQuery": false
    },
    {
      "id": "birthday",
      "type": "input",
      "step": "4",
      "title": "birthday",
      "text": "When was [name] born?",
      "blocks": [
        {
          "id": "dob",
          "type": "date",
          "inputLabel": "Select year, then month",
          "inputTag": "input",
          "placeholder": "MM/DD/YYYY"
        }
      ],
      "buttonText": "Next",
      "tip": "This helps us recommend the right plan and recipes!",
      "useInResultsQuery": false
    },
    {
      "id": "is-infant",
      "type": "is-infant",
      "step": "1",
      "title": "is-infant",
      "text": "",
      "blocks": [
        {
          "id": "email",
          "type": "text",
          "inputTag": "input",
          "placeholder": "Email Address",
          "inputLabel": "Your email"
        }
      ],
      "description": "Thanks so much for visiting Once Upon a Farm! The American Academy of Pediatrics recommends the introduction of solid foods at 6 months of age. Check back when your baby reaches 6 months and we’ll provide the best organic, nutrient-rich, and Clean Label Project certified recipes to give your baby a strong start!",
      "buttonText": "Next"
    },
    {
      "id": "baby-nutrition-goals",
      "type": "single-select",
      "step": "",
      "title": "baby-nutrition-goals",
      "text": "When it comes to feeding [name], what is important?",
      "blocks": [
        {
          "id": "goal",
          "type": "single-select",
          "options": [
            {
              "label": "Blends",
              "value": "Blends to start solids",
              "imageUrl": "",
              "nextQuestion": "prep"
            },
            {
              "label": "New textures and flavors",
              "value": "New textures and flavors",
              "imageUrl": "",
              "nextQuestion": "prep"
            },
            {
              "label": "Finger foods",
              "value": "Baby-led weaning",
              "imageUrl": "",
              "nextQuestion": "weekly-quantity"
            }
          ]
        }
      ],
      "buttonText": "Next",
      "tip": "This helps us recommend the right plan and recipes!",
      "useInResultsQuery": true
    },
    {
      "id": "toddler-dietary-preferences",
      "type": "multiple-select",
      "step": "",
      "title": "toddler-dietary-preferences",
      "text": "When it comes to feeding [name], what is most important?",
      "blocks": [
        {
          "id": "dietary",
          "type": "multiple-select",
          "inputTag": "select",
          "options": [
            {
              "label": "No Added Sugar",
              "value": "No Added Sugar",
              "imageUrl": "https://cdn.shopify.com/s/files/1/0499/3122/3193/files/No_Added_Sugar.png?v=1644026296",
              "nextQuestion": "toddler-nutrition-goals"
            },
            {
              "label": "Organic & Non-GMO",
              "value": "Organic & Non-GMO",
              "imageUrl": "https://cdn.shopify.com/s/files/1/0499/3122/3193/files/Organic_Non-GMO.png?v=1644026296",
              "nextQuestion": "toddler-nutrition-goals"
            },
            {
              "label": "Clean Ingredients",
              "value": "Clean Ingredients",
              "imageUrl": "https://cdn.shopify.com/s/files/1/0499/3122/3193/files/Clean_Ingredients.png?v=1644026296",
              "nextQuestion": "toddler-nutrition-goals"
            },
            {
              "label": "Refrigerated",
              "value": "Refrigerated",
              "imageUrl": "https://cdn.shopify.com/s/files/1/0499/3122/3193/files/Refrigerated.png?v=1644026296",
              "nextQuestion": "toddler-nutrition-goals"
            },
            {
              "label": "Dairy & Gluten-Free",
              "value": "Dairy & Gluten-Free",
              "imageUrl": "https://cdn.shopify.com/s/files/1/0499/3122/3193/files/Dairy_Gluten-Free.png?v=1644026296",
              "nextQuestion": "toddler-nutrition-goals"
            }
          ]
        }
      ],
      "buttonText": "Next",
      "nextQuestion": "toddler-nutrition-goals",
      "tip": "This helps us recommend the right plan and recipes!",
      "useInResultsQuery": false
    },
    {
      "id": "toddler-nutrition-goals",
      "type": "multiple-select",
      "step": "",
      "title": "toddler-nutrition-goals",
      "text": "When it comes to feeding [name], what are you looking for?",
      "blocks": [
        {
          "id": "goal",
          "type": "multiple-select",
          "inputTag": "select",
          "options": [
            {
              "label": "Immunity",
              "value": "Immunity",
              "imageUrl": "https://cdn.shopify.com/s/files/1/1889/4791/files/Immunity.png?v=1671533036",
              "nextQuestion": "weekly-quantity"
            },
            {
              "label": "Omega-3s",
              "value": "Omega-3s",
              "imageUrl": "https://cdn.shopify.com/s/files/1/1889/4791/files/Omega-3s.png?v=1671533150",
              "nextQuestion": "weekly-quantity"
            },
            {
              "label": "Added Veggies & Superfoods",
              "value": "Added Veggies & Superfoods",
              "imageUrl": "https://cdn.shopify.com/s/files/1/0499/3122/3193/files/Added_Veggies_Superfoods.png?v=1644026296",
              "nextQuestion": "weekly-quantity"
            },
            {
              "label": "Probiotics",
              "value": "Probiotics",
              "imageUrl": "https://cdn.shopify.com/s/files/1/0499/3122/3193/files/Probiotics.png?v=1644026296",
              "nextQuestion": "weekly-quantity"
            },
            {
              "label": "Protein",
              "value": "Protein",
              "imageUrl": "https://cdn.shopify.com/s/files/1/1889/4791/files/Protein.png?v=1671533275",
              "nextQuestion": "weekly-quantity"
            }
          ]
        }
      ],
      "buttonText": "Next",
      "nextQuestion": "weekly-quantity",
      "tip": "This helps us recommend the right plan and recipes!",
      "useInResultsQuery": true
    },
    {
      "id": "prep",
      "type": "single-select",
      "step": "",
      "title": "prep",
      "text": "Do you have time to prepare food, or do you want fresh snacks for on-the-go?",
      "blocks": [
        {
          "id": "prep",
          "type": "single-select",
          "options": [
            {
              "label": "No Prep",
              "value": "No Prep",
              "imageUrl": "",
              "nextQuestion": "weekly-quantity"
            },
            {
              "label": "Prep",
              "value": "Prep",
              "imageUrl": "",
              "nextQuestion": "weekly-quantity"
            },
            {
              "label": "Both",
              "value": "Both",
              "imageUrl": "",
              "nextQuestion": "weekly-quantity"
            }
          ]
        }
      ],
      "buttonText": "Next",
      "tip": "This helps us recommend the right plan and recipes!",
      "useInResultsQuery": true
    },
    {
      "id": "weekly-quantity",
      "step": "",
      "type": "single-select",
      "title": "weekly-quantity",
      "text": "How many nutritious and delicious snacks do you expect your little ones to enjoy each week?",
      "blocks": [
        {
          "id": "weekly-quantity",
          "type": "single-select",
          "options": [
            {
              "label": "Less than 7",
              "value": "Less than 7",
              "imageUrl": "",
              "nextQuestion": "email"
            },
            {
              "label": "7-14",
              "value": "7-14",
              "imageUrl": "",
              "nextQuestion": "email"
            },
            {
              "label": "14-21",
              "value": "14-21",
              "imageUrl": "",
              "nextQuestion": "email"
            },
            {
              "label": "More than 21",
              "value": "More than 21",
              "imageUrl": "",
              "nextQuestion": "email"
            }
          ]
        }
      ],
      "buttonText": "Next",
      "tip": "This helps us recommend the right plan and recipes!",
      "useInResultsQuery": false
    },
    {
      "id": "email",
      "step": "",
      "type": "input",
      "title": "email",
      "text": "Tell us where we should send your results",
      "blocks": [
        {
          "id": "email",
          "type": "text",
          "inputTag": "input",
          "placeholder": "",
          "inputLabel": "Email"
        }
      ],
      "buttonText": "Next",
      "tip": "This helps us recommend the right plan and recipes!",
      "useInResultsQuery": false
    }
  ]
}
/* eslint-enable */

export const STEP_LABEL_MAPPING = {
  intro: 'Customer Information',
  children: 'Child Information',
  birthday: 'Birth Date',
  'baby-nutrition-goals': 'Importance',
  'toddler-dietary-preferences': 'Benefit',
  'toddler-nutrition-goals': 'Benefit',
  prep: 'Time',
  'weekly-quantity': 'Amount'
}

export const DIETARY_PREFERENCES_LABEL_MAPPING = {
  'No Added Sugar': 'no_sugar',
  'Organic & Non-GMO': 'organic',
  'Clean Ingredients': 'clean',
  'Refrigerated': 'refrigerated',
  'Dairy & Gluten-Free': 'dairy_free'
}

export const NUTRITION_GOALS_LABEL_MAPPING = {
  'Blends to start solids': 'blends',
  'New textures and flavors': 'new',
  'Baby-led weaning': 'finger',
  'Immunity': 'immune',
  'Omega-3s': 'brain',
  'Added Veggies & Superfoods': 'superfoods',
  'Probiotics': 'probiotics',
  'Protein': 'protein'
}

export const PREPS_LABEL_MAPPING = {
  'No Prep': 'noprep',
  'Prep': 'prep',
  'Both': 'both'
}
